<template>
  <v-app-bar fixed class="app-toolbar">
    <v-app-bar-nav-icon @click.stop="handleDrawerToggle"></v-app-bar-nav-icon>
    <v-spacer></v-spacer>
     <!-- Language Selector -->
    <language-selector></language-selector>
    
    <v-menu
      offset-y
      origin="center center"
      :nudge-bottom="10"
      transition="scale-transition"
      class="pr-3"
    >
      <template v-slot:activator="{ on }">
        <v-btn large text v-on="on" class="ml-2 pl-4" style="border-left: 1px solid var(--border-color); border-radius: 0; min-width: auto; padding-right: 0;">
          <div class="d-flex align-center">
            <div class="mr-3 text-left d-none d-sm-block" style="text-transform: none;">
              <div class="text-body-2 font-weight-bold" style="color: #1e293b">{{userName}}</div>
              <div class="text-caption" style="color: #64748b; line-height: 1;">{{userRoleName}}</div>
            </div>
            <v-avatar size="36px" color="orange darken-1" class="elevation-1">
              <span class="white--text font-weight-bold">{{ userName.substring(0,2).toUpperCase() }}</span>
            </v-avatar>
          </div>
        </v-btn>
      </template>
      <v-list class="pa-0">
        <v-list-item
          v-for="(item,index) in items"
          :to="!item.href ? { name: item.name } : null"
          :href="item.href"
          @click="item.click"
          ripple="ripple"
          :disabled="item.disabled"
          :target="item.target"
          rel="noopener"
          :key="index"
        >
          <v-list-item-action v-if="item.icon">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
// import NotificationList from "@/components/widgets/list/NotificationList";
import Util from "@/util";
import LanguageSelector from "@/components/general/LanguageSelector";
// import { mapState } from "vuex";
// import moment from "moment";
import _ from "lodash";
import configs from "@/configs";
export default {
  name: "app-toolbar",
  components: {
    LanguageSelector
  },
  data: () => ({
    items: [
      {
        icon: "manage_accounts",
        href: "/tai-khoan",
        title: "Tài khoản",
        click: e => {
          this.$router.push({ path: "tai-khoan" });
        }
      },
      {
        icon: "logout",
        href: "#",
        title: "Đăng xuất",
        click: () => {
          window.getApp.$emit("APP_LOGOUT");
        }
      }
    ]
  }),
  computed: {
    toolbarColor() {
      return this.$vuetify.options.extra.mainNav;
    },
    userName() {
      return this.$store.state.authentication.user.username;
    },
    userRoleName() {
      const user = this.$store.state.authentication.user;
      if (user) {
        const role = _.find(configs.ROLES, { value: user.roleid });
        return role ? role.name : "";
      }
      return "";
    },
  },
  methods: {
    handleDrawerToggle() {
      window.getApp.$emit("APP_DRAWER_TOGGLED");
    },
    handleFullScreen() {
      Util.toggleFullScreen();
    }
  },
  destroyed() {
    clearInterval(this.timer);
  }
};
</script>
